import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const orlaRioTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#0f70b7',
    },
    secondary: {
      main: '#000000',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#0f70b7',
    },
  },
};
